import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/locale/i18n'
import demo from './demo/index'
import easter from './easter/index'
import birthday from './birthday/index'
import greenchannel from './greenchannel/index'
import everyDaySpecial from './everyDaySpecial/index'
import activity5G from './activity5G/index'
import other from './other/index'
import mobileDevice from './mobileDevice/index'
import paymentRule from './paymentRule/index'
import concert from './concert/index'
import solution from './solution/index'
import shangtang from './shangtang/index'
import page500 from '@/page/page500'
import download from '@/page/download'
import videoList from '@/page/videoList'
import videoPlay from '@/page/videoPlay'
import aesUrl from '@/page/aesUrl'
import lucky from '@/page/lucky'
import topUp from '@/page/topUp'
import register from '@/page/register'
import storyList from '@/page/5gRewritesStory/list'
import storyDetail from '@/page/5gRewritesStory/detail'
import UDI from '@/page/UDI'
import openScreen from '@/page/openScreen/openScreen'
import FPS from '@/page/FPS/FPS'
import FPSTesting from '@/page/FPS/FPSTesting'
import selectSkin from '@/page/selectSkin/selectSkin'
import skinPreview from '@/page/selectSkin/skinPreview'

Vue.use(Router)

const router = new Router({
    routes: [
        ...demo,
        ...easter,
        ...solution,
        ...shangtang,
        ...concert,
        ...birthday,
        ...greenchannel,
        ...mobileDevice,
        ...paymentRule,
        ...everyDaySpecial,
        ...other,
        ...activity5G,
        {
            path: '/page500',
            component: page500,
            meta: {title: i18n.t('global.netEttor.oterError')}
        },
        {
            path: '/download',
            component: download,
            meta: {title: i18n.t('global.share.title')}
        },
        {
            path: '/video',
            component: videoList,
            meta: {title: i18n.t('greenchannel.channel3')}
        },
        {
            path: '/lucky',
            component: lucky,
            meta: {title: i18n.t('lucky.title')}
        },
        {
            path: '/topUp',
            component: topUp,
            meta: {title: i18n.t('lucky.topUp.title')}
        },
        {
            path: '/video-play',
            component: videoPlay,
            meta: {title: '\u200E'}
        },
        {
            path: '/aesUrl',
            component: aesUrl,
            meta: {title: '\u200E'}
        },
        {
            path: '/register',
            component: register,
            meta: {title: i18n.t('register.title')}
        },
        {
            path: '/5g-story',
            component: storyList,
            meta: {title: '5G改寫我們的故事'}
        },
        {
            path: '/5g-story/:id',
            component: storyDetail,
            meta: {title: '5G改寫我們的故事'}
        },
        {
            path: '/openScreen',
            component: openScreen,
            meta: {title: i18n.t('activity5G.openScreen.title')}
        },
        {
            path: '/FPS',
            component: FPS,
            meta: {title: ''}
        },
        {
            path: '/FPSTesting',
            component: FPSTesting,
            meta: {title: i18n.t('FPS.hCenter.f1')}
        },
        {
            path: '/selectSkin',
            component: selectSkin,
            meta: {title: ''}
        },
        {
            path: '/skinPreview',
            component: skinPreview,
            meta: {title: ''}
        }
    ]
})
router.beforeEach((to, from, next) => {
    // 根据路由 meta 信息更改页面 title
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js